.MileageContainer
    position: relative
    padding: 0
    border-radius: $globalButtonRounding
    overflow: hidden

.Waiting
    position: absolute
    top: 0
    bottom: 0
    left: 0
    right: 0
    background: rgb($globalSettingsBackgroundPrimary)
    opacity: 0.3
    cursor: wait
